import React from "react";
import { Row, Col } from "reactstrap";

interface Props {
  mdVotes: number;
  txVotes: string;
  txUnvotes: string;
}

export const VotersUnvoters: React.FC<Props> = ({
  mdVotes,
  txVotes,
  txUnvotes,
}) => {
  return (
    <>
      <Row style={{ padding: "10px" }}>
        <Col
          md={mdVotes + 1}
          style={{ background: "#03BE9A", padding: "15px" }}
          className="left-half-pill"
        >
          <div>{txVotes}</div>
        </Col>
        <Col
          md={`${10 - mdVotes + 1}`}
          style={{ background: "#FC78A4", padding: "15px" }}
          className="right-half-pill"
        >
          <div>{txUnvotes}</div>
        </Col>
      </Row>
    </>
  );
};
